import { render } from "./OrderSummaryCard.vue?vue&type=template&id=ca201284"
import script from "./OrderSummaryCard.vue?vue&type=script&lang=js"
export * from "./OrderSummaryCard.vue?vue&type=script&lang=js"

import "./OrderSummaryCard.vue?vue&type=style&index=0&id=ca201284&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__